var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col2",class:_vm.classWrap},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"inner"},[_vm._t("container"),_c('div',{staticClass:"colPrimary"},[_vm._t("colPrimary")],2),_c('div',{staticClass:"colSecondary"},[_vm._t("colSecondary")],2)],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }